<template>
  <div class="reward-query-content">
    <div class="title">奖励发放记录</div>
    <van-popover
      v-model="showPopover"
      trigger="click"
    >
      <template #default>
        <div class="data-content">
          <div :class="['monthData',{'active':item.formatDate==choiceDate}]" v-for="(item,index) in dataList" :key="index" @click="onSelect(item)">{{ item.formatDate }}</div>
        </div>
      </template>
      <template #reference>
        <div class="month-choice">
          <div>{{ currentDate }}</div>
          <div class="tringle"></div>
        </div>
      </template>
    </van-popover>
    <div class="reward-list" v-if="list.length>0">
      <div class="reward-title">
        <div class="column1 column">发奖人</div>
        <div class="column2 column">学生</div>
        <div class="column3 column">奖励</div>
        <div class="column4 column">数量</div>
      </div>
      <div class="reword-content">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div v-for="(item,index) in list" :key="index" class="reward-item">
            <div class="column1 item-column text-type1">{{ item.grantUserName }}</div>
            <div class="column2 item-column">
              <div class="text-type1 showColumn1">{{ item.studentName }}</div>
              <div class="text-type2">{{ item.studentPhone }}</div>
            </div>
            <div class="column3 item-column">
              <div class="text-type1">{{ item.propRewardName }}</div>
              <div class="text-type2">{{ item.propRewardTime }}</div>
            </div>
            <div class="column4 item-column text-type1">{{ item.propGrantNum }}</div>
          </div>
        </van-list>
      </div>
    </div>
    <div class="empty" v-else>
      <img
        src="@/assets/images/squirrelCup/2024/cupTwo/empty.png"
        alt=""
        class="empty-img"
      />
      <div class="empty-text">暂无奖励记录</div>
    </div>
  </div>
</template>

<script>
import { getPropGrantRecordList } from "@/api/squirrelCup";
import { Toast } from 'vant';
export default {
  data() {
    return {
      showPopover: false,
      currentDate: '',
      currentYear: null,
      currentMonth: null,
      choiceYear: null,
      choiceMonth: null,
      choiceDate: null,
      openId: null,
      dataList:[],
      list: [],
      addList: [],
      totalNumber: null,
      loading: false,
      finished: false,
      pageIndex: 1,
      pageSize: 10,
    }
  },
  mounted() {
    document.title = "奖励发放记录";
    this.getCurrentData();
    this.fetchRewardRecords(this.pageIndex,this.pageSize);
  },
  methods: {
    onSelect(item) {
      this.currentDate = item.formatDate;
      this.choiceYear = item.year;
      this.choiceMonth = item.month;
      this.choiceDate = item.formatDate;
      this.pageIndex = 1;
      this.fetchRewardRecords(this.pageIndex,this.pageSize);
      this.showPopover = false;
    },
    // 获取当前日期以及初始化日期选择列表，可选当前日期往前半年，设置最早可选日期为2024年7月
    getCurrentData() {
      const now = new Date();
      this.currentYear = now.getFullYear();
      this.currentMonth = now.getMonth() + 1;
      this.choiceYear = this.currentYear;
      this.choiceMonth = this.currentMonth;
      this.currentDate = `${this.currentYear}.${this.currentMonth.toString().padStart(2, '0')}`;
      this.choiceDate = this.currentDate;
      for(let i = 0; i < 6; i++){
        let month = this.currentMonth-i;
        if(month < 7 && this.currentYear<=2024){
          return;
        }
        if(month <= 0){
          month = 12 + month;
          this.dataList.push({
            year: this.currentYear - 1,
            month: month,
            formatDate: `${this.currentYear - 1}.${month.toString().padStart(2, '0')}`
          });
        }else{
          this.dataList.push({
            year: this.currentYear,
            month: month,
            formatDate: `${this.currentYear}.${month.toString().padStart(2, '0')}`
          })
        }
      }
    },
    async fetchRewardRecords(pageIndex, pageSize) {
      try {
        const userInfo = JSON.parse(localStorage.getItem("userInfoId"));
        const params = {
          param: {
            campusId: Number(userInfo.campusId),
            year: this.choiceYear,
            month: this.choiceMonth,
          },
          pageIndex,
          pageSize,
        };
        console.log('params:', params);

        const res = await getPropGrantRecordList({ ...params });

        if (res.code === 0) {
          if(this.pageIndex == 1){
            this.list = res.data.body;
            this.totalNumber = res.data.count;
            this.loading = false;
            this.finished = false;
            console.log('成功了',this.pageIndex,this.totalNumber,res.data.count,this.finished,this.loading);
          }else{
            this.list.push(...res.data.body);
          }
        } else {
          Toast(res.message);
        }
      } catch (err) {
        Toast(err);
      }
    },
    onLoad() {
      if(this.list.length >= this.totalNumber){
        this.finished = true;
        return;
      }else{
        this.pageIndex++;
        this.fetchRewardRecords(this.pageIndex,this.pageSize);
        this.loading = false;
      }
    }
  },
}
</script>


<style lang='less' scoped>
.data-content {
  max-height: 312px;
  overflow-y: auto;
  .monthData {
    width: 216px;
    height: 68px;
    font-size: 28px;
    color: #323232;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .active {
    color: #58ABF6;
  }
}
.reward-query-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .title {
    margin-top: 40px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 34px;
    color: #323232;
    line-height: 48px;
  }
  .month-choice {
    margin-top: 24px;
    width: 216px;
    height: 56px;
    background: #F6F9FD;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 28px;
    font-weight: 400;
    font-size: 28px;
    color: #323232;
    line-height: 40px;
    .tringle {
      width: 0;
      height: 0;
      border: 0 solid transparent;
      border-left: 10px solid transparent;
      border-right: 10px solid transparent;
      border-top: 16px solid #ccc;
      margin-left: 20px;
    }
  }
  .empty {
    margin-top: 152px;
    .empty-img {
      height: 244px;
    }
    .empty-text {
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #000000;
      line-height: 40px;
      text-align: center;
      margin-top: 48px;
    }
  }
}
.van-list {
  width: 100%;
}
.reward-list {
  width: 100%;
  margin-top: 32px;
  .reward-title {
    display: flex;
    width: 100%;
    height: 82px;
    background: rgba(88,171,246,0.12);
  }
  .reword-content {
    max-height: calc(100vh - 320px);
    overflow: auto;
  }
  .column {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 24px;
    font-weight: 600;
    color: #323232;
  }
  .column1 {
    width: 20%;
    text-align: center;
    max-height: 80px;
  }
  .column2 {
    width: 30%;
  }
  .column3 {
    width: 38%;
  }
  .column4 {
    width: 12%;
  }
  .item-column {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .text-type1 {
    font-weight: 400;
    font-size: 28px;
    color: #323232;
    line-height: 40px;
    text-overflow: ellipsis;
    display: -webkit-box; /* 必须组合的属性 */
    -webkit-box-orient: vertical; /* 必须组合的属性 */
    -webkit-line-clamp: 2; /* 显示的行数 */
    overflow: hidden; /* 隐藏超出的内容 */
    text-align: center;
    word-break: break-word; /* 强制换行处理长单词 */
    overflow-wrap: break-word; /* 处理长单词或无空格内容的换行 */
  }
  .showColumn1 {
    -webkit-line-clamp: 1 !important; /* 显示的行数 */
  }
  .text-type2 {
    font-weight: 400;
    font-size: 24px;
    color: #999999;
    line-height: 34px;
  }
}
.reward-item {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  // padding: 20px 0;
  box-sizing: border-box;
  height: 120px;
  border-bottom: 1px solid rgba(88,171,246,0.2);
}
</style>